import React, { useEffect, useState } from 'react';
import HomeIngManTeams from "../Home/Teams/HomeIngManTeams";
import MyCollaboratorIngRes from './Partials/MyCollaboratorIngRes';

import DirRespService from '../../../../../services/Ing/DirResp/DirRespService';
import MbeGantt from '../../../../../components/Molecules/Gantt/MbeGantt';

const CalendarIngManager = () => {

	const [timeToRealod, setTimeToRealod] = useState(false)

	const [projectUnassigned, setProjectUnassigned] = React.useState([])
	const getProjectUnassigned = async () => {
		const request = await DirRespService.getAllUnassignedProjects()
		if (request.status === 200) {
			setProjectUnassigned(request.data["hydra:member"])
		}
	}

	useEffect(() => {
		getProjectUnassigned()
	}, [timeToRealod]);


	return (
		<section className="mbe-section">
			<HomeIngManTeams teams={projectUnassigned} timeToRealod={() => setTimeToRealod(!timeToRealod)} />

			<MyCollaboratorIngRes />

			<div className="my-collaborator-container">
				<h3 className="color-primary">Planning de charge</h3>
				<MbeGantt />
			</div>
		</section>
	);
};

export default CalendarIngManager;
